import { Component, Input, OnInit } from '@angular/core';
import get from 'lodash-es/get';

import { HeaderAlignmentService } from '@finder/shared/services/header-alignment/header-alignment.service';
import { MultiCta } from './multi-cta.interface';
import { ALLOW_TRACKING } from '@finder/shared/directives/link-id/link-id.constants';
import { CommonModule } from '@angular/common';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';
import { LinkIdDirective } from '@finder/shared/directives/link-id/link-id.directive';
import { AriaLabelHtmlDirective } from '@finder/shared/directives/aria-label-html/aria-label-html.directive';
import { LocaleDirective } from '@finder/shared/directives/locale/locale.directive';

@Component({
    selector: 'finder-multi-cta',
    templateUrl: './multi-cta.component.html',
    styleUrls: ['./multi-cta.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ComponentHeaderComponent,
        FontIconComponent,
        SafeHtmlPipe,
        LinkIdDirective,
        LocaleDirective,
        AriaLabelHtmlDirective, // finderAriaLabelHtml
    ],
})
export class MultiCtaComponent implements OnInit {
    @Input() data: MultiCta;

    singleText = false;
    allowTracking = ALLOW_TRACKING;

    constructor(
        private headerAlignmentService: HeaderAlignmentService,
    ) { }

    ngOnInit() {
        this.data = Object.assign(this.data || {}, this.headerAlignmentService.getHeaderAlignment(this.data));
        this.singleText = get(this.data, 'link', []).length === 1;
    }
}
